export const ESTADOS_COBRO = {
  NO_COBRADO: 0,
  COBRADO: 1,
  PARCIALMENTE_COBRADA: 2,
} as const

export type EstadosCobroType =
  (typeof ESTADOS_COBRO)[keyof typeof ESTADOS_COBRO]
